"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropFile = void 0;
var react_1 = __importStar(require("react"));
var react_dropzone_1 = require("react-dropzone");
var styled_components_1 = __importDefault(require("styled-components"));
var notification_1 = require("../../hook/notification");
exports.DropFile = react_1.default.memo(function (props) {
    var _a;
    var label = props.label, accept = props.accept, uploading = props.uploading, disabled = props.disabled, multiple = props.multiple, numberOfMaximumFiles = props.numberOfMaximumFiles, maximumFileSize = props.maximumFileSize, acceptExtensions = props.acceptExtensions, messageWhenSpecifiedUnsupportedExtension = props.messageWhenSpecifiedUnsupportedExtension, messageWhenExceedingMaximumFiles = props.messageWhenExceedingMaximumFiles, messageWhenExceedingMaximumFileSize = props.messageWhenExceedingMaximumFileSize, action = __rest(props, ["label", "accept", "uploading", "disabled", "multiple", "numberOfMaximumFiles", "maximumFileSize", "acceptExtensions", "messageWhenSpecifiedUnsupportedExtension", "messageWhenExceedingMaximumFiles", "messageWhenExceedingMaximumFileSize"]);
    var notify = (0, notification_1.useNotify)();
    var onDrop = (0, react_1.useCallback)(function (files) {
        if (!files) {
            return;
        }
        if (numberOfMaximumFiles && messageWhenExceedingMaximumFiles && files.length > numberOfMaximumFiles) {
            notify({ message: messageWhenExceedingMaximumFiles, severity: "error" });
            return;
        }
        if (maximumFileSize && messageWhenExceedingMaximumFileSize && files.some(function (file) { return file.size > maximumFileSize; })) {
            notify({ message: messageWhenExceedingMaximumFileSize, severity: "error" });
            return;
        }
        if ((acceptExtensions === null || acceptExtensions === void 0 ? void 0 : acceptExtensions.length) &&
            messageWhenSpecifiedUnsupportedExtension &&
            files.some(function (file) { var _a; return !acceptExtensions.includes(((_a = file.name.split(".").pop()) === null || _a === void 0 ? void 0 : _a.toLocaleLowerCase()) || ""); })) {
            notify({ message: messageWhenSpecifiedUnsupportedExtension, severity: "error" });
            return;
        }
        var _loop_1 = function (i) {
            var file = files[i];
            if ("onFile" in action) {
                action.onFile(file);
                return "continue";
            }
            var reader = new FileReader();
            if ("onBuffer" in action) {
                reader.readAsArrayBuffer(file);
                reader.onload = function () {
                    if (reader.result !== null && typeof reader.result === "object") {
                        action.onBuffer(Buffer.from(reader.result));
                    }
                };
            }
            else if ("onText" in action) {
                reader.readAsText(file, action.encoding || "utf8");
                reader.onload = function () {
                    if (typeof reader.result === "string") {
                        action.onText(reader.result);
                    }
                };
            }
        };
        for (var i = 0; i < files.length; i++) {
            _loop_1(i);
        }
    }, [
        acceptExtensions,
        action,
        maximumFileSize,
        messageWhenExceedingMaximumFileSize,
        messageWhenExceedingMaximumFiles,
        messageWhenSpecifiedUnsupportedExtension,
        notify,
        numberOfMaximumFiles,
    ]);
    var _b = (0, react_dropzone_1.useDropzone)({
        onDrop: onDrop,
        accept: accept ? (_a = accept.split(",")) === null || _a === void 0 ? void 0 : _a.reduce(function (memo, key) {
            var _a;
            return (__assign(__assign({}, memo), (_a = {}, _a[key] = [], _a)));
        }, {}) : undefined,
        disabled: disabled || uploading,
        multiple: multiple,
    }), getRootProps = _b.getRootProps, getInputProps = _b.getInputProps, isDragActive = _b.isDragActive;
    return (react_1.default.createElement(Dropper, __assign({}, getRootProps(), { isDragActive: isDragActive, disabled: disabled }),
        react_1.default.createElement("input", __assign({}, getInputProps())),
        uploading ? (react_1.default.createElement(Line, null, "\u30A2\u30C3\u30D7\u30ED\u30FC\u30C9\u4E2D\u30FB\u30FB\u30FB")) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(Icon, null,
                react_1.default.createElement("svg", { width: "32", height: "32", viewBox: "0 0 64 64", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                    react_1.default.createElement("path", { d: "M16.2371 24.3831L21.6885 24.3831L21.6885 40.8537C21.6885 42.6655 23.2314 44.1479 25.1171 44.1479L38.8314 44.1479C40.7171 44.1479 42.2599 42.6655 42.2599 40.8537L42.2599 24.3831L47.7114 24.3831C50.7628 24.3832 52.3056 20.8255 50.1456 18.7502L34.4085 3.63021C33.0714 2.3455 30.9114 2.3455 29.5742 3.63021L13.8371 18.7502C11.6771 20.8255 13.1857 24.3831 16.2371 24.3831Z", fill: "#707683" }),
                    react_1.default.createElement("path", { d: "M8 55.3725C8 57.1843 9.54286 58.6667 11.4286 58.6667H52.5714C54.4571 58.6667 56 57.1843 56 55.3725C56 53.5608 54.4571 52.0784 52.5714 52.0784H11.4286C9.54286 52.0784 8 53.5608 8 55.3725Z", fill: "#707683" }))),
            react_1.default.createElement(Line, null,
                "\u3053\u3053\u306B\u30D5\u30A1\u30A4\u30EB\u3092\u30C9\u30ED\u30C3\u30D7\u3001\u307E\u305F\u306F",
                react_1.default.createElement(Underline, null, "\u30D5\u30A1\u30A4\u30EB\u3092\u9078\u629E"),
                "\u3057\u3066\u304F\u3060\u3055\u3044\u3002"),
            props.notes ? props.notes.map(function (note) { return react_1.default.createElement(Line, { key: note }, note); }) : null))));
});
var Icon = styled_components_1.default.p(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var Dropper = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  font-size: 13px;\n  width: 100%;\n  height: 160px;\n  border: 2px dashed ", ";\n  border-radius: 8px;\n  background-color: ", ";\n"], ["\n  cursor: pointer;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  font-size: 13px;\n  width: 100%;\n  height: 160px;\n  border: 2px dashed ", ";\n  border-radius: 8px;\n  background-color: ", ";\n"])), function (props) { return (props.isDragActive ? "blue" : "#C8CDD8"); }, function (props) {
    return props.isDragActive ? "#0000ff33" : props.disabled ? props.theme.colors.gray3 : "#F5F6F8";
});
var Line = styled_components_1.default.p(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin: 0;\n  margin-bottom: 16px;\n"], ["\n  margin: 0;\n  margin-bottom: 16px;\n"])));
var Underline = styled_components_1.default.span(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  color: #325a95;\n  font-weight: bold;\n  text-decoration: underline;\n"], ["\n  color: #325a95;\n  font-weight: bold;\n  text-decoration: underline;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
